import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionTimeoutModalComponent } from './shared/components/session-timeout-modal/session-timeout-modal.component';
import { PwaInstallPromptComponent } from './shared/components/pwa-install-prompt/pwa-install-prompt.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SessionTimeoutModalComponent, PwaInstallPromptComponent],
  template: `
    <router-outlet />
    <app-session-timeout-modal />
    <app-pwa-install-prompt />
  `,
  styles: [`:host { display: block; }`],
})
export class App { }
